import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Globals } from "@foh/globals";

@Injectable({
  providedIn: "root"
})
export class ReservationformService {
  constructor(private globals: Globals, private http: HttpClient) {}

  retrieveProfile() {
    return this.http.get(
      this.globals.WEBAPI + this.globals.URL_CUSTOMERPROFILE_PROFILE);
  }

  saveProfile(params) {
    return this.http.post(
      this.globals.WEBAPI + this.globals.URL_CUSTOMERPROFILE_UPDATE,params);
  }

  retrieveMetadata(params: {}) {
    return this.http.post(
      this.globals.WEBAPI + this.globals.URL_FBFORM_RETRIEVE_METADATA,
      params
    );
  }

  retrieveReservationDetails(params: {}) {
    return this.http.get(
      this.globals.WEBAPI + this.globals.URL_FBFORM_RETRIEVE_RESERVATION,
      { params: params }
    );
  }
  checkGuestList(params: {}) {
    return this.http.get(
      this.globals.WEBAPI + this.globals.URL_FBFORM_GUESTLIST_CHECK,
      { params: params }
    );
  }

  addReservation(params) {
    return this.http.post(
      this.globals.WEBAPI + this.globals.URL_FBFORM_ADD_RESERVATION,
      params
    );
  }

  cancelReservation(params) {
    return this.http.post(
      this.globals.WEBAPI + this.globals.URL_FBFORM_CANCEL_RESERVATION,
      params
    );
  }

  editReservation(params) {
    return this.http.post(
      this.globals.WEBAPI + this.globals.URL_FBFORM_EDIT_RESERVATION,
      params
    );
  }

  retrieveSoldTickets(params) {
    return this.http.get(
      this.globals.WEBAPI + this.globals.URL_FBFORM_RETRIEVE_SOLDTICKETS_COUNT,
      { params: params }
    );
  }
}
